module.exports = {"131002001":"银河南路街道","131002002":"光明西道街道","131002003":"永华道街道","131002100":"落垡镇","131002101":"码头镇","131002102":"葛渔城镇","131002103":"东沽港镇","131002104":"调河头镇","131002105":"北史家务镇","131002106":"杨税务镇","131002201":"仇庄乡","131002400":"廊坊龙河高新技术产业开发区","131002401":"河北廊坊高新技术产业开发区","131002402":"河北廊坊龙港经济开发区","131002403":"河北安次经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131002.json
// module id = 319
// module chunks = 0